export default __webpack_public_path__ + "static/media/7.893f6ede.mp3";